import {createElement, Component, PropTypes} from 'rlink-react';
import {deepEquals} from 'rlink-utils/object';
import defaultStyle from 'rlink-modal/Modal.less';

export default class Modal extends Component {
  componentDidMount () {
    this.setState({closing: false});
    if (this.props.bindOnCloseToClassNames.length > 0) {
      this._tryToClose = ev => {
        let matchingClassNames = this.props.bindOnCloseToClassNames.filter(elem => ev.target.classList.contains(elem));
        if (matchingClassNames.length > 0) {
          document.removeEventListener('click', this._tryToClose);
          this.close(ev);
        }
      };
    }
    if (this.props.open === true) {
      document.body.classList.add(this.props.css['no-scroll']);
      if (this.props.bindOnCloseToClassNames.length > 0) {
        document.addEventListener('click', this._tryToClose);
      }
    }
  }

  componentWillUnmount () {
    if (!this.state.closing) { //need to check if Close Modal callback is being bypassed
      document.body.classList.remove(this.props.css['no-scroll']);
      this.setState({closing: true});
    }
  }

  shouldComponentUpdate (nextProps, _nextState) {
    return (!deepEquals(this.props, nextProps));
  }

  close (ev) {
    if (this.state.closing === false) {
      ev.stopPropagation();
      ev.preventDefault();
      if (document.querySelectorAll(`.${this.props.css['modal-open']}.${this.props.css['modal-content']}`).length === 1) { // need to check if we're the last modal closing
        document.body.classList.remove(this.props.css['no-scroll']);
      }

      this.props.closeModal(ev);
      this.setState({closing: true});
    }
  }

  render () {
    let transform = undefined;

    if (!this.props.fullscreen) {
      const MAX_NUDGE_DISTANCE = 2;
      let nudgeOffset = Number(this.props.nudgeOffset);
      let divisor = (this.props.stackSize - 1 === 0)
        ? 0
        : this.props.stackIdx / (this.props.stackSize - 1);
      let nudge = `${((divisor * (MAX_NUDGE_DISTANCE)) + MAX_NUDGE_DISTANCE) - nudgeOffset}%`;

      transform = `translate(${nudge}, ${nudge})`;
    }

    let stackIdx = this.props.stackIdx;
    let style = {};

    if (typeof stackIdx === 'number' && !isNaN(stackIdx)) {
      style.zIndex = 1000 + stackIdx * 10;
    }

    return (
      <div style={style} className={`${this.props.css.modal} modal ${this.props.isFlyout ? 'flyout' : ''}`}>
        {(!this.props.isFlyout && !this.props.fullscreen)
          && <div onClick={ev => this.close(ev)} className={`${this.props.css['modal-overlay']}`} />}
        <div
          data-unique-id={this.props.uniqueId}
          className={`${this.props.css[this.props.className]} ${this.props.open ? this.props.css['modal-open'] : ''}`}>
          <div className={`${this.props.css['modal-open']} ${this.props.css['modal-content']}`} style={{WebkitTransform: transform}}>
            {(this.props.async) ? this.renderAsync() : this.props.children}
          </div>
        </div>
      </div>
    );
  }

  renderAsync () {
    let content = [];
    if (this.props.open || this.props.loadOnce) {
      if (this.props.showLoader) {
        content.push(<div className={this.props.css['ajax-loader']} />);
      }

      content.push(this.props.children);
    }

    return content;
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  css: PropTypes.object,
  async: PropTypes.bool,
  uniqueId: PropTypes.string,
  isFlyout: PropTypes.bool,
  stackSize: PropTypes.number,
  stackIdx: PropTypes.number,
  nudgeOffset: PropTypes.number,
  closeModal: PropTypes.func,
  children: PropTypes.node,
  open: PropTypes.bool,
  loadOnce: PropTypes.bool,
  showLoader: PropTypes.bool,
  fullscreen: PropTypes.bool,
  bindOnCloseToClassNames: PropTypes.arrayOf(PropTypes.string),
};

Modal.defaultProps = {
  className: '',
  css: defaultStyle,
  async: false,
  mobileOverlayOpaque: false,
  isFlyout: false,
  fullscreen: false,
  bindOnCloseToClassNames: [],
};



// WEBPACK FOOTER //
// ./lib/rlink-modal/Modal.jsx